var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirplaneTakeoffRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2082_1314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.08594 13.6108H17.9193V15.2775H2.08594V13.6108Z",
    fill: "#E5444D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2854 11.0666C17.4672 10.4018 17.0682 9.70955 16.3992 9.53499L11.9754 8.34729L9.66044 0.823503L8.06952 0.39573L8.06981 7.29523L3.92885 6.18424L3.14879 4.25201L1.93984 3.9293L1.93665 6.96817L1.93818 8.24884L3.26788 8.6124L7.69588 9.79289L11.3186 10.7682L15.7382 11.9632C16.4228 12.1274 17.1036 11.7315 17.2854 11.0666Z",
    fill: "#E5444D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2082_1314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplaneTakeoffRed);
export default __webpack_public_path__ + "static/media/airplane-takeoff-red.dddec469c6076ac4221ea782246e58df.svg";
export { ForwardRef as ReactComponent };